import ChooseTime from "../../components/ClassOne/Mathematics/ChooseTime";
import TimeQuestion from "../../components/ClassOne/Mathematics/TimeQuestion";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/clock/choose-correct", title: "Choose Correct Time", component: ChooseTime },
    { url: "/class-one/mathematics/clock/multiple-choice-question", title: "Multiple Choice Question", component: TimeQuestion },
];

export default topics;